var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "slide",
    {
      staticClass: "order-flow__wrapper--3",
      attrs: {
        title: _vm.title,
        validated: _vm.isValid,
        "overwrite-save-btn": true
      },
      on: {
        next: function($event) {
          return _vm.submit()
        }
      }
    },
    [
      _c("template", { slot: "content" }, [
        _c(
          "div",
          {
            staticClass: "order-tiles",
            class: { "order-tiles--selection": _vm.isValid }
          },
          [
            _c(
              "div",
              {
                staticClass: "order-tiles__item order-tiles__item--1",
                class: {
                  "order-tiles__item--selected": _vm.intOwnerType === "person"
                },
                on: {
                  click: function($event) {
                    return _vm.selectType("person")
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: "/assets/img/icons/icon-company-1.svg",
                    alt: "Ikon af person"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "order-tiles__item__heading" }, [
                  _vm._v("Person")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "order-tiles__item__text" }, [
                  _vm._v("Anparterne ejes direkte personligt")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "order-tiles__item order-tiles__item--2",
                class: {
                  "order-tiles__item--selected": _vm.intOwnerType === "selskab"
                },
                on: {
                  click: function($event) {
                    return _vm.selectType("selskab")
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: "/assets/img/icons/icon-company-2.svg",
                    alt: "Ikon af selskab"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "order-tiles__item__heading" }, [
                  _vm._v("Selskab")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "order-tiles__item__text" }, [
                  _vm._v("Anparterne ejes af et eksisterende kapitalselskab")
                ])
              ]
            )
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bd7314f", { render: render, staticRenderFns: staticRenderFns })
  }
}